import { memo } from 'react';
import type { FC } from 'react';
import useWindowWidth from "../common/WindowWidth"
import { GenericSlider } from "../common/GenericSlider/GenericSlider"
import { useTranslation,Trans } from 'react-i18next';

import resets from '../_resets.module.css';
import classes from './About_edu.module.scss';



/*Title*/
import { SectionTitle } from "../common/SectionTitle/SectionTitle";
import { SectionTitle_sub } from "../common/SectionTitle_sub/SectionTitle_sub";

/*section*/
import { PageTitle } from "../common/PageTitle/PageTitle";
import { PointCarousel } from "./PointCarousel/PointCarousel";
import { Contact } from "../common/Contact/Contact";

/*Button*/
import { Button_ellipse } from "../common/Button/Button_ellipse/Button_ellipse";

/*images*/
import ExpectedEffectsImg_beside from "../../assets/images/point_chart_230919.png";
import ExpectedEffectsImg_beside_sp from "../../assets/images/point_chart_sp_230919.png";
import ExpectedEffectsImg_beside_en from "../../assets/images/point_chart_EN_01.png";
import ExpectedEffectsImg_beside_sp_en from "../../assets/images/point_chart_EN_01sp.png";
import Example_img01 from "../../assets/images/iMG_133021.jpeg";
import Example_img02 from "../../assets/images/iMG_133121.jpeg";
import Example_img03 from "../../assets/images/IMG_3594.png";
import Example_img04 from "../../assets/images/IMG_3604.png";



interface Props {
  className?: string;
}

const customSettings = {
  dots: false, 
  arrows: false,
  slidesToShow: 1,
  centerPadding: '20%',
};


export const About_edu: FC<Props> = memo(function About_edu(props = {}) {
  const { t,i18n } = useTranslation();
  const windowWidth = useWindowWidth();
  const currentLanguage = i18n.language;
  const isEnglish = currentLanguage === 'en';
  
  const image = isEnglish ? ExpectedEffectsImg_beside_en : ExpectedEffectsImg_beside;
  const image_sp = isEnglish ? ExpectedEffectsImg_beside_sp_en : ExpectedEffectsImg_beside_sp;


  return (

    <div className={`${resets.clapyResets} ${classes.aboutEdu} aboutEdu contents`}>

<PageTitle
          className={classes.pageTitle}
          title={t('about:pageTitle')}
        />

 {/*point------------*/}
<section className={classes.point}>
  <SectionTitle
            className={classes.pointTitle}
            text="POINT"
          />
          <SectionTitle_sub
            className={classes.pointSubTitle}
            text={t('about:pointSubTitle')}
          />
  <PointCarousel />
</section>

{/*expectedEffects------------*/}
<section className={`${classes.expectedEffects} LargeMarginUnder`}>
  <h2 className={classes.expectedEffectsTitle}>{t('about:expectedEffects.expectedEffectsTitle')}</h2>

  <div className={classes.expectedEffectsImg}>
   <picture>
      <source media="(max-width: 768px)" srcSet={image_sp} />
      <source media="(min-width: 769px)" srcSet={image} />
      <img src={image} className={classes.expectedEffectsImg} />
    </picture>
</div>
  <div className={classes.expectedEffectsText}><span className={classes.underLine}>{t('about:expectedEffects.expectedEffectsText01')}</span><span className={classes.underLine}>{t('about:expectedEffects.expectedEffectsText02')}</span></div>
</section>

{/*Usage example------------*/}
<section className={`${classes.usageExampleSection} contentWidth`}>
<SectionTitle className={classes.usageExampleTitle}>
  <Trans i18nKey="about:usageExample.title" />
</SectionTitle>
        <div className={classes.usageExampleLeadText}>{t('about:usageExample.leadText')}</div>


  <ul className={classes.usageExampleList}>
          <li className={classes.usageExampleListItem}>
            <div className={classes.usageExampleItemTitle}>{t('about:usageExample.examples.physicalEducation.title')}</div>
            <div className={classes.usageExampleItemSubtitle}>{t('about:usageExample.examples.physicalEducation.subtitle')}</div>
          </li>
          <li className={classes.usageExampleListItem}>
            <div className={classes.usageExampleItemTitle}>{t('about:usageExample.examples.clubActivities.title')}</div>
            <div className={classes.usageExampleItemSubtitle}>{t('about:usageExample.examples.clubActivities.subtitle')}</div>
          </li>
          <li className={classes.usageExampleListItem}>
            <div className={classes.usageExampleItemTitle}>{t('about:usageExample.examples.schoolEvents.title')}</div>
            <div className={classes.usageExampleItemSubtitle}>{t('about:usageExample.examples.schoolEvents.subtitle')}</div>
          </li>
          <li className={classes.usageExampleListItem}>
            <div className={classes.usageExampleItemTitle}>{t('about:usageExample.examples.inquiryLearning.title')}</div>
            <div className={classes.usageExampleItemSubtitle}>{t('about:usageExample.examples.inquiryLearning.subtitle')}</div>
          </li>
        </ul>
  <Button_ellipse
    className={classes.usageExampleDetailsButton}
    link="/about/usage-ex"
  />

</section>

{/*exampleimages------------*/}
<div className={`${classes.exampleImages} exampleImages`}>
    {windowWidth <= 768 ? (
      <GenericSlider settings={customSettings}>
        <div>
          <img src={Example_img01} className={classes.exampleImage} />
        </div>
        <div>
          <img src={Example_img02} className={classes.exampleImage} />
        </div>
        <div>
          <img src={Example_img03} className={classes.exampleImage} />
        </div>
        <div>
          <img src={Example_img04} className={classes.exampleImage} />
        </div>
      </GenericSlider>
    ) : (
      <ul className={classes.exampleImageList}>
        <li className={classes.exampleImageListItem}>
          <img src={Example_img01} className={classes.exampleImage} />
        </li>
        <li className={classes.exampleImageListItem}>
          <img src={Example_img02} className={classes.exampleImage} />
        </li>
        <li className={classes.exampleImageListItem}>
          <img src={Example_img03} className={classes.exampleImage} />
        </li>
        <li className={classes.exampleImageListItem}>
          <img src={Example_img04} className={classes.exampleImage} />
        </li>
      </ul>
    )}
  </div>



{/*contact------------*/}
<Contact className={classes.contact} />
    </div>
  );
});
